import { useContext } from 'react';

import { CampaignCountryMetadata } from '@features/campaigns/shared/providers/CampaignCountryProvider/buildCampaignCountryMetadata.ts';
import { CampaignCountryContext } from '@features/campaigns/shared/providers/CampaignCountryProvider/providerSetup.ts';

export function useCampaignCountry(): CampaignCountryMetadata {
  const context = useContext(CampaignCountryContext);

  if (!context) {
    throw new Error('useCampaignCountry must be used within a CampaignCountryProvider');
  }

  return context;
}
